import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import { initDeferredScripts } from './utils/deferredScripts'

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Charge MTCaptcha + gtag après le premier signe d'interaction ou en idle.
// Libère le main thread au boot → améliore INP / TBT sur mobile.
initDeferredScripts();
